export default __webpack_public_path__ + "static/image11-c00247ed2a98c428e67bec7cd3d5a31b.jpg";